module.exports = __webpack_public_path__ + "static/img/b1.7f0030b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b1.png
// module id = 74rB
// module chunks = 1